<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>网上预约</el-breadcrumb-item>
      <el-breadcrumb-item>我的预约</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row>
        <el-col :span="12">
          <div></div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-button @click="getAppoin">新增预约</el-button>
          </div>
        </el-col>
      </el-row>
      <el-dialog title="新增预约" :visible.sync="dialogVisible" width="50%" destroy-on-close>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row :span="24">
            <el-col :span="10">
              <el-form-item label="预约时间：" prop="appointmentDate">
                <el-date-picker v-model="ruleForm.appointmentDate" type="datetime" placeholder="选择日期时间" align="right"
                  :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss" default-time>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4"></el-col>
            <el-col :span="10">
              <el-form-item label="预约地址：" prop="adress">
                <el-input v-model="ruleForm.adress"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="预约时长：" prop="duration">
                <el-input v-model="ruleForm.duration" type="number" placeholder="时长以分钟为单位"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="预约内容：" prop="content">
            <el-input v-model="ruleForm.content" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="预约老师" prop="teacherGroup">
            <span>老师</span>
            <el-checkbox-group v-model="ruleForm.teacherGroup">
              <el-checkbox :label="user.userid" name="type" v-show="user.type==0" v-for="(user,index) in teacherList"
                :key="index">{{user.name}}</el-checkbox>
            </el-checkbox-group>
            <span>辅导员</span>
            <el-checkbox-group v-model="ruleForm.teacherGroup">
              <el-checkbox :label="user.userid" name="type" v-show="user.type==5" v-for="(user,index) in teacherList"
                :key="index">{{user.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="subRuleForm">提交</el-button>
        </span>
      </el-dialog>
      <el-dialog title="点评打分" :visible.sync="dialogUpdate" width="25%" destroy-on-close>
        <el-form :model="updateForm" status-icon :rules="rulesUpdate" ref="ruleUpdate" label-width="100px"
          class="demo-ruleForm">
          <el-form-item label="评价留言：" prop="studentRemark">
            <el-input :disabled="isMark!=null?true:false" v-model="updateForm.studentRemark" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="打分：" prop="studentMark">
            <el-input type="number" :disabled="isMark!=null?true:false" v-model="updateForm.studentMark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogUpdate = false">取 消</el-button>
          <el-button v-if="isMark==null" type="primary" @click="subUpdateForm">提交</el-button>
        </span>
      </el-dialog>
      <el-table ref="ieltsList" :data="apponinList" border show-overflow-tooltip="true" tooltip-effect="dark"
        style="width: 100%">
        <el-table-column prop="appointmentDate" :show-overflow-tooltip="true" label="预约时间" width="180">
        </el-table-column>
        <el-table-column prop="adress" :show-overflow-tooltip="true" label="预约地点" width="180">
        </el-table-column>
        <el-table-column prop="duration" :show-overflow-tooltip="true" label="预约时长（分钟）" width="140">
        </el-table-column>
        <el-table-column prop="content" :show-overflow-tooltip="true" label="预约内容" width="180">
        </el-table-column>
        <el-table-column prop="name" :show-overflow-tooltip="true" label="约定老师" width="180">
        </el-table-column>
        <el-table-column prop="teacherGroupName" :show-overflow-tooltip="true" label="预约老师" width="180">
        </el-table-column>
        <el-table-column prop="isSuccess" label="预约状态" width="100" :formatter="stateFormat">
        </el-table-column>
        <el-table-column label="点评" width="90">
          <template slot-scope="scope">
            <!-- <el-button  @click="deleteMenus(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button> -->
            <el-button v-show="scope.row.isSuccess==1" @click="updateApp(scope.row)"><svg class="icon"
                aria-hidden="true">
                <use xlink:href="#icon-xiugai" v-if="scope.row.studentMark==null"></use>
                <use xlink:href="#icon-chakan2" v-if="scope.row.studentMark!=null"></use>
              </svg></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  created() {
    this.getAppoinment()
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      dialogVisible: false,
      dialogUpdate: false,
      isMark: '',
      teacherList: [],
      apponinList: [],
      ruleForm: {
        appointmentDate: '',
        adress: '',
        content: '',
        teacherGroup: [],
        studentId: '',
        duration: '',
      }, updateForm: {
        appointmentId: '',
        studentMark: '',
        studentRemark: '',
      },
      rules: {
        teacherGroup: [
          { type: 'array', required: true, message: '至少选择一位老师', trigger: 'change' },
        ], adress: [
          { required: true, message: '请输入地址', trigger: 'blur' },
        ], content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ], appointmentDate: [
          { required: true, message: '请选择预约时间', trigger: 'blur' },
        ], duration: [
          { required: true, message: '请输入预约时长', trigger: 'blur' },
          { min: 1, max: 3, message: '请输入合理时间', trigger: 'blur' }
        ]
      }, rulesUpdate: {
        studentMark: [
          { required: true, message: '请打分', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    getAppoinment() {
      this.axios.post("/apponintment/selectApponintment?studentId=" + JSON.parse(localStorage.getItem("user")).userid)
        .then((resp) => {
          if (resp.data.status == 1) {
            console.log(resp.data.result)
            this.apponinList = resp.data.result
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
    },
    stateFormat(row, column) {
      if (row.isSuccess == 1) {
        return '预约成功'
      } else if (row.appointmentDate < this.$formateDate.formateDate(Date.now())) {
        return '已过时'
      } else if (row.isSuccess === null) {
        return '暂未预约'
      } else {
        return '已查看'
      }
    },
    getAppoin() {
      this.dialogVisible = true
      this.axios.post("/user/getTeacherUser")
        .then((resp) => {
          if (resp.data.status == 1) {
            console.log(resp.data.result)
            this.teacherList = resp.data.result
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
    }, subRuleForm() {
      this.$refs.ruleForm.validate((val => {
        if (!val)
          return
        this.gerTeacherName()
        this.ruleForm.studentId = JSON.parse(localStorage.getItem("user")).userid
        let config = { headers: { "Content-Type": "application/json" } }
        this.axios.post("/apponintment/insertApponintment", this.ruleForm, config)
          .then((resp) => {
            if (resp.data.status == 1) {
              this.$message.success("新增成功");
              this.getAppoinment()
              this.$refs.ruleForm.resetFields()
              this.dialogVisible = false
            } else {
              alert("拿取数据失败");
            }
          })
          .catch((err) => {
            this.$message.error("出错");
          });
      }))
    }, gerTeacherName() {
      var name = ''
      var num = this.ruleForm.teacherGroup.length;
      this.teacherList.forEach(element => {
        console.log(this.ruleForm)
        for (let i = 0; i < num; i++) {
          if (this.ruleForm.teacherGroup[i] == element.userid) {
            if (i < num - 1) {
              if(name=''){
                name = element.name 
              }else{
                name = name + ','+ element.name 
              }
              
            } else {
              name = name + element.name
            }
          }
          this.ruleForm.teacherGroupName = name
        }
      });
    }, updateApp(data) {
      this.dialogUpdate = true
      this.updateForm.appointmentId = data.appointmentId
      this.updateForm.studentMark = data.studentMark
      this.updateForm.studentRemark = data.studentRemark
      this.isMark = data.studentMark
    }, subUpdateForm() {
      this.ruleForm.studentId = JSON.parse(localStorage.getItem("user")).userid
      let config = { headers: { "Content-Type": "application/json" } }
      this.axios.post("/apponintment/updateByAppointmentId", this.updateForm, config)
        .then((resp) => {
          if (resp.data.status == 1) {
            this.$message.success("修改成功");
            this.getAppoinment()
            this.$refs.ruleUpdate.resetFields()
            this.dialogUpdate = false
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
    },
  },

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/student/Apponintment.vue